/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */
@file:UseContextualSerialization(LocalDate::class)

package pl.finn.forms.sekap1794

import io.kvision.types.LocalDate
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseContextualSerialization
import pl.finn.forms.Zalacznik

@Serializable
data class Sekap1794Form(
  val miejscowosc: String? = null,
  val data: LocalDate? = null,
  val nazwaPodmiotu: String? = null,
  val adresEmail: String? = null,
  val adresKodPocztowy: String? = null,
  val adresMiejscowosc: String? = null,
  val adresUlica: String? = null,
  val adresBudynek: String? = null,
  val adresLokal: String? = null,
  val dotyczyWniosku: String? = null,
  val numerWniosku: String? = null,
  val dotyczyCzego: String? = null,
  val temat: String? = null,
  val tresc: String? = null
)

@Serializable
data class Sekap1794FormData(
  val form: Sekap1794Form,
  val zalaczniki: List<Zalacznik>,
  val podmiotNazwa: String?,
  val podmiotMiejscUrz: String?,
  val url: String,
  val token: String?
)
